import mixpanel from 'mixpanel-browser';
// Firebase
import { db, auth, storage, functions } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, serverTimestamp, orderBy, increment, startAfter, limit, onSnapshot, arrayUnion, arrayRemove } from 'firebase/firestore';
import { ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { httpsCallable } from 'firebase/functions';

import {
    GET_GROUP,
    GET_GROUPS,
    GET_MODAL_GROUPS,
    SET_SELECTED_GROUP,
    SET_GROUPS,
    SET_LAST_GROUPS,
    GROUP_ERROR,
    CLEAR_GROUPS,
    CLEAR_GROUP,
    GROUPS_LOADING,
    UPDATE_GROUP,
    GROUP_UPDATE_LOADED,
    GROUP_UPDATE_LOADING,
    SET_SHOW_BOTTOM_SPINNER_4_GROUPS,
    SET_LAST_GROUP_DOC,
    SET_NO_MORE_GROUPS
} from './types';
import { setAlert } from './alertActions';
import { followGroup } from './authActions';
import MAX_FOLLOW_COUNT from '../utils/constant_variables/MAX_FOLLOW_COUNT';

// Reference to collections in Firestore
const postsCollectionRef = collection(db, "posts");
const groupsCollectionRef = collection(db, "campuses");
const usersCollectionRef = collection(db, "users");

// Declare cloud function for use in this file
const createNotification_InCloud = httpsCallable(functions, 'createNotification');

// Get group by id
export const getGroupById = id => async dispatch => {

    // Dispatch the clearGroup action to reset the user state
    dispatch(clearGroup());
    try {
        const docRef = doc(db, 'campuses', id)

        // Retrieve the document with the specified id from the collection
        const groupDoc = await getDoc(docRef);
        
        console.log('GOT GROUP BY ID');

        if(groupDoc.data()) {

            const groupData = {
                ...groupDoc.data(),
                _id: id
            }

            // Dispatch an action of type GET_POST with the post data and ID as the payload
            dispatch({
                type: GET_GROUP,
                payload: groupData
            });

            // Set selected group as well (so TweetBox is synced to current group viewing)
            dispatch({
                type: SET_SELECTED_GROUP,
                payload: groupData
            });
        } else {
            dispatch({
                type: GET_GROUP,
                payload: null
            });

            // Set selected group as well (so TweetBox is synced to current group viewing)
            dispatch({
                type: SET_SELECTED_GROUP,
                payload: null
            });

            dispatch(setAlert('Sorry, this group has been deleted.', 'okay'));
        }
    } catch (err) {

        // If an error occurs, dispatch the GROUP_ERROR action with an error message and status code as the payload
        dispatch({
            type: GROUP_ERROR,
            payload: { msg: "something went wrong", status: 500 }
        });
        console.log(err);
    }
}

// Get groups current user is following
export const getFollowingGroups = (currentUser, page_size) => async dispatch => {
    
    console.log('ABOUT TO GET FOLLOWING GROUPS');

    // dispatch(clearGroups());
    dispatch(setGroupsLoading());

    const PAGE_LIMIT = page_size;

    try {
        const groupsList = await getFollowingGroups_Helper({ currentUser, page_size: PAGE_LIMIT });
    
        // Dispatch an action to update the state with the retrieved groupsList
        if(groupsList.length < (PAGE_LIMIT - 1) && PAGE_LIMIT >= 2) {
            dispatch({
                type: SET_LAST_GROUPS,
                payload: groupsList
            });
        } else {
            dispatch({
                type: SET_GROUPS,
                payload: groupsList
            });
        }

    } catch (err) {
        console.log("ERROR! COULDN'T GET FOLLOWING GROUPS")
        console.log(err)

        // Dispatch an action to handle the error
        dispatch({
            type: GROUP_ERROR,
            payload: []
        })
    }
};

// Get groups current user is an admin of
export const getMyGroups = (currentUser, lastPageDoc) => async dispatch => {
    
    console.log('ABOUT TO GET MY GROUPS');

    // dispatch(clearGroups());
    if(!lastPageDoc) dispatch(setGroupsLoading());

    const PAGE_LIMIT = 15;

    try {

        const groupsList = await getMyGroups_Helper({ currentUser, lastPageDoc, page_size: PAGE_LIMIT });

        let lastDocument = groupsList[groupsList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified document 
            const docRef = doc(groupsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID
            const groupDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch(set_LastPageDoc(groupDoc));

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action to update the state with the retrieved groupsList
        if(groupsList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_GROUPS,
                payload: groupsList
            });
        } else {
            dispatch({
                type: SET_GROUPS,
                payload: groupsList
            });
        }

    } catch (err) {
        console.log("ERROR! COULDN'T GET MY GROUPS")
        console.log(err)

        // Dispatch an action to handle the error
        dispatch({
            type: GROUP_ERROR,
            payload: []
        })
    }
};

// Get groups that include search_tag
export const getGroupsBySearchTag = (search_tag, lastPageDoc) => async dispatch => {
    
    console.log('ABOUT TO GET GROUPS BY SEARCH TAGS');

    // dispatch(clearGroups());
    if(!lastPageDoc) dispatch(setGroupsLoading());

    const PAGE_LIMIT = 15;

    try {
        const groupsList = await getGroupsBySearchTag_Helper({ search_tag, lastPageDoc, page_size: PAGE_LIMIT });

        let lastDocument = groupsList[groupsList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified document 
            const docRef = doc(groupsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID
            const groupDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch(set_LastPageDoc(groupDoc));

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action to update the state with the retrieved groupsList
        if(groupsList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_GROUPS,
                payload: groupsList
            });
        } else {
            dispatch({
                type: SET_GROUPS,
                payload: groupsList
            });
        }

    } catch (err) {
        console.log("ERROR! HELPER FAILED TO GET GROUPS BY SEARCH TAG")
        console.log(err);

        // Dispatch an action to handle the error
        dispatch({
            type: GROUP_ERROR,
            payload: []
        })
    }
};

// Get groups current user is an admin of
export const getNewGroups = (lastPageDoc) => async dispatch => {
    
    console.log('ABOUT TO GET NEW GROUPS');

    // dispatch(clearGroups());
    if(!lastPageDoc) dispatch(setGroupsLoading());

    const PAGE_LIMIT = 15;

    try {
        const groupsList = await getNewGroups_Helper({ lastPageDoc, page_size: PAGE_LIMIT });

        let lastDocument = groupsList[groupsList.length - 1];

        if(lastDocument) {

            // Create a reference to the specified document 
            const docRef = doc(groupsCollectionRef, lastDocument._id);

            // Retrieve the document with the specified ID
            const groupDoc = await getDoc(docRef);

            // Set the last visible document for the next load
            dispatch(set_LastPageDoc(groupDoc));

            dispatch(set_ShowBottomSpinner(false));
        }

        // Dispatch an action to update the state with the retrieved groupsList
        if(groupsList.length < (PAGE_LIMIT - 1) && lastPageDoc) {
            dispatch({
                type: SET_LAST_GROUPS,
                payload: groupsList
            });
        } else {
            dispatch({
                type: SET_GROUPS,
                payload: groupsList
            });
        }

    } catch (err) {
        console.log("ERROR! COULDN'T GET NEW GROUPS")
        console.log(err)

        // Dispatch an action to handle the error
        dispatch({
            type: GROUP_ERROR,
            payload: []
        })
    }
};

// Get group by id
export const getSelectedGroupById = id => async dispatch => {

    console.log('Getting selected group by id');
    // Dispatch the clearGroup action to reset the user state
    dispatch(clearGroup());
    try {
        const docRef = doc(db, 'campuses', id)

        // Retrieve the document with the specified id from the collection
        const groupDoc = await getDoc(docRef);
        
        console.log('GOT GROUP BY ID');

        if(groupDoc.data()) {
            // Dispatch an action of type GET_POST with the post data and ID as the payload
            dispatch({
                type: SET_SELECTED_GROUP,
                payload: {
                    ...groupDoc.data(),
                    _id: id
                }
            });
        } else {
            dispatch({
                type: SET_SELECTED_GROUP,
                payload: null
            });

            dispatch(setAlert('Sorry, that group has been deleted.', 'okay'));
        }
    } catch (err) {

        // If an error occurs, dispatch the GROUP_ERROR action with an error message and status code as the payload
        dispatch({
            type: GROUP_ERROR,
            payload: { msg: "something went wrong", status: 500 }
        });
        console.log(err);
    }
}

// Set selected group
export const setSelectedGroup = (group_obj) => async dispatch => {
    
    console.log('SETTING SELECTED GROUP');

    dispatch({
        type: SET_SELECTED_GROUP,
        payload: group_obj
    });
};

// Fill the groups array with everything in the given array
export const setGroups = arrayOfGroups => dispatch => {
    console.log('SETTING GROUPS NOW');

    dispatch({
        type: SET_GROUPS,
        payload: arrayOfGroups
    });
};

// Create Group
export const createGroup = ( 
    formData, 
    avatarData
) => async dispatch => {
    
    try {

        // Extract the necessary data from the formData object
        const {
            name,
            description,
            privacy,
            user,
            relevant_keywords
        } = formData;

        if(!user) throw new Error('No user data');

        let search_tags = [];

        if(relevant_keywords?.trim()) {
            search_tags = relevant_keywords
                .toLowerCase()
                .split(',')
                .map(word => word.trim());
        }

        // Create a new document in the "posts" collection with the post data
        const result = await addDoc(groupsCollectionRef, {
            name,
            description,
            privacy,
            can_discover: true,
            creator: {_id: user._id, first_name: user.first_name, last_name: user.last_name, img: user.img},
            admins: [user._id],
            avatar: null,
            follower_count: 0,
            date: Date.now(),
            createdAt: serverTimestamp(),
            lastModified: serverTimestamp(),
            search_tags,
        });

        console.log('NEW GROUP CREATED');

        // Mixpanel event tracking for post submission
        if (process.env.NODE_ENV === 'production' && user) {
            mixpanel.track("Create Group", {
                "First Name": `${user.first_name}`,
                "Last Name": `${user.last_name}`,
                "Group Name": `${name}`
            });
        }

        // Auto follow this group for current user
        dispatch(followGroup(result.id, user));
   
        // --- Add avatar img to group ---

        // Get the document reference for the post
        const docRef = doc(db, 'campuses', result.id);

        // Get img file extension for firebase url
        var fileExt = avatarData.name.split('.').pop();
        
        // Create a storage reference for the image
        const storageRef = ref(storage, `media/groups/${result.id}/avatar/${avatarData.name}`);

        // Upload the image file to the storage
        const res = await uploadBytesResumable(storageRef, avatarData);

        console.log('Uploaded a blob or file!');

        // Get the download URL of the uploaded image
        const imgPath = await getDownloadURL(storageRef);

        await updateDoc(docRef, {
            avatar: imgPath
        });

        // Add flag to trigger alert after redirect THEN redirect to new group
        localStorage.setItem("trigger_alert", "group_success");

        // Set a timeout to give enough time for the post to be added
        setTimeout(() => {

            // Display an alert message to notify the user that the post was sent
            // dispatch(setAlert('Posted! Your post was sent.', 'okay'));
            window.location.href = `/groups/${result.id}?show=posts`;
        }, 1000 );

        // --- END Add avatar to group ---

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err);
    //   dispatch({
    //     type: POST_ERROR,
    //     payload: { msg: err.response.statusText, status: err.response.status }
    //   });
    }
};

// Add New Follow Request to Group
export const requestToFollowGroup = ({ group, fromUser }) => async dispatch => {
    
    if(!fromUser) throw new Error('No user data');
    if(!group) throw new Error('No group data');
    
    try {
        console.log('REUESTING TO FOLLOW GROUP!!!!!');

        // Get the current list of follow_requests from the group data
        const requestList = group.follow_requests ?? [];

        let alreadyRequested = requestList.filter(followRequest => followRequest.user._id.toString() === fromUser._id).length > 0;

        // Create the new follow request object
        const newRequest = {
            user: {
                _id: fromUser._id,
                username: fromUser.username,
                first_name: fromUser.first_name,
                last_name: fromUser.last_name,
                img: fromUser.img
            }
        };

        // Get Firebase group doc ref
        const groupRef = doc(groupsCollectionRef, group._id);

        // Update the user document with the updated groups list
        await updateDoc(groupRef, {
            follow_requests: alreadyRequested ? arrayRemove(newRequest) : arrayUnion(newRequest),
        })

        console.log('SUCCESSFULLY TOGGLED FOLLOW REQUEST');
  
    } catch (err) {
        console.log('Error: Failed to request follow')
        console.log(err.message);

        // Choose to display general or specific error message
        throw new Error('Something went wrong');
    }
};

// Accept Follow Request
export const acceptFollowRequest = async ({ request_obj, groupId, groupName, groupAvatar }) => {
    
    console.log('ABOUT TO ACCEPT FOLLOW REQUEST')

    if(!request_obj) throw new Error('No request data');

    let userData;
    let fromUserRef;

    // Get User Data
    try {
        // Get Firebase doc ref
        fromUserRef = doc(usersCollectionRef, request_obj.user._id);

        const userDoc = await getDoc(fromUserRef);
        
        console.log('GOT FROM USER DOC');

        if(userDoc.data()) {
            userData = {
                ...userDoc.data(),
                _id: userDoc.id
            }
        }
    } catch (error) {
        console.log("Failed while trying to accept follow request, couldn't get user data.")
        console.log(error);

        throw new Error("Couldn't get user data.");
    }
    
    try {
        if(!userData) throw new Error('No user data');

        // Get the current list of groups from the fromUser data
        const groupList = userData.groups || [];

        let alreadyFollows = groupList.filter(temp_groupId => temp_groupId.toString() === groupId).length > 0;

        console.log('ACCEPTING FOLLOW REQUEST')
        
        // Check if group already followed by from user
        if(alreadyFollows) {
            throw new Error('User already follows group');
        }

        // FLAG: restrict number of groups user can follow
        // 'Following feed' query will instantly crash if user follows more than 30 groups due to firebase limitations
        if(groupList.length >= MAX_FOLLOW_COUNT) {
            throw new Error("Max follow count reached.");
        }

        // Get Firebase doc ref
        const groupRef = doc(groupsCollectionRef, groupId);

        // Remove the from user's follow request from the group document
        await updateDoc(groupRef, {
            follow_requests: arrayRemove(request_obj)
        });

        // Add the new group id to the from user document
        await updateDoc(fromUserRef, {
            groups: arrayUnion(groupId)
        })

        console.log('SUCCESSFULLY ACCEPTED FOLLOW REQUEST');

        // -- Add 'User Joined Community' post to show in feed --

        try {
            // Create a new document in the "posts" collection with type "new user"
            // Shows special post in feed when a new user joins completes verification
            await addDoc(postsCollectionRef, {
                campus_id: groupId,
                type: "new user",
                text: null,
                category: null,
                username: `${userData.first_name}${userData.last_name && ' ' + userData.last_name}`,
                user: {
                    _id: userData._id,
                    username: userData.username,
                    first_name: userData.first_name,
                    last_name: userData.last_name
                },
                group: {
                    _id: groupId
                },
                avatar: null,
                post_commented_on: null,
                img_count: null,
                likes: [],
                comments: [],
                date: Date.now(),
                createdAt: serverTimestamp(),
                lastModified: serverTimestamp()
            });

            console.log('CREATED POST ABOUT USER JOINING');
        } catch (error) {
            console.log("Failed to add post about New User Joining Community!");
            console.log(error);
        }

        // -- END: Add 'User Join Community' post to show in feed --

        // -- Send Notification --

        const payload = {
            type: 'accept request',
            groupId: groupId,
            message: null,
            toId: userData._id,
            from_username: groupName,
            avatar: groupAvatar,
            date: Date.now()
        }

        // Trigger cloud function to create notification
        createNotification_InCloud(payload)
            .then(() => console.log("Notification created successfully!"))
            .catch((err) => console.log("Notification failed to create"));

        // -- END: Send Notification --

    } catch (err) {
        console.log('Error: Failed to accept request')
        console.log(err.message);

        // Choose to display general or specific error message
        if(err.message.toLowerCase().includes("max follow count reached")) {
            throw new Error("User is following too many groups"); 
        } else {
            throw new Error('Failed to Accept Request');
        }
    }
};

// Deny Follow Request
export const denyFollowRequest = async ({ request_obj, groupId }) => {
    
    console.log('ABOUT TO DENY FOLLOW REQUEST')

    if(!request_obj) throw new Error('No request data');
    
    try {

        console.log('DENYING FOLLOW REQUEST')

        // Get Firebase doc ref
        const groupRef = doc(groupsCollectionRef, groupId);

        // Remove the from user's follow request from the group document
        await updateDoc(groupRef, {
            follow_requests: arrayRemove(request_obj)
        });

        console.log('SUCCESSFULLY DENIED FOLLOW REQUEST');

    } catch (err) {
        console.log('Error: Failed to deny request')
        console.log(err.message);

        throw new Error('Failed to Deny Request');
    }
};

// Update auth inputs
export const editGroupName = (formData) => async dispatch => {

    dispatch(setGroupUpdateLoading());

    const { name, groupId } = formData;

    // Reference to the user document in the Firestore database
    const groupDoc = doc(db, "campuses", groupId);

    console.log('UPDATING GROUP NAME');

    // Try block to handle the update operation
    try {

        console.log('ABOUT TO UPDATE GROUP NAME');
        
        // Update the user document with the new first name and last name
        await updateDoc(groupDoc, {
            name
        })

        // --- UPDATE ALL GROUP POSTS ---

        const postsQuery = query(postsCollectionRef, where("group._id", "==", groupId));
        const selectedPosts = await getDocs(postsQuery);

        for (const doc of selectedPosts.docs) {

            const selectedPost = await getDoc(doc.ref);

            await updateDoc(doc.ref, {
                ...selectedPost.data(),
                group: {
                    ...selectedPost.data().group,
                    name: name,
                },
            });

        }

        // END UPDATE POSTS

        // Get updated Group data for display
        const updatedGroupDoc = await getDoc(groupDoc);

        console.log('GOT UPDATED GROUP');
  
        // Dispatch an action to update the authentication state with the updated user data
        dispatch({
            type: UPDATE_GROUP,
            payload: { ...updatedGroupDoc.data(), _id: groupId }
        });

        // Dispatch a success alert to notify the user about the profile update
        dispatch(setAlert('Group Updated', 'success'));
        dispatch(setGroupUpdateLoaded());

    } catch (err) {
        console.log('ERRORS')
        console.log(err);
        
        if(err.response) {
            const errors = err.response.data.errors;

            // Dispatch error alerts for each error message received
            if(errors) {
                errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
            }
        } else {

            // Dispatch a generic error alert if no specific error information is available
            setAlert('Something went wrong', 'danger')
        }
    }
}

// Update group description
export const editGroupDescription = (formData) => async dispatch => {
    const { description, groupId } = formData;

    // Reference to the group document in the Firestore database
    const groupRef = doc(db, "campuses", groupId);

    console.log('UPDATING GROUP DESCRIPTION')

    // Try block to handle the update operation
    try {

        // Log the group's bio data received
        console.log('UPDATING GROUP DESCRIPTION')

        // Get updated User data for display
        const groupSnapshot = await getDoc(groupRef);

        if (!groupSnapshot.exists()) {
            console.log("Group doesn't exist");
            throw new Error("Group doesn't exist. Could't edit description");
        }

        let group_obj = {...groupSnapshot.data(), _id: groupId};

        // Update the group's description
        await updateDoc(groupRef, {
            description: description,
        })

        // Update group data for frontend display purposes (don't want to call DB a too many times in one function)
        group_obj.description = description;

        console.log('GOT UPDATED USER BY ID');
  
        // Dispatch an action to update the authenticated group's information with the updated data
        dispatch({
            type: UPDATE_GROUP,
            payload: group_obj
        });

        // Dispatch a success alert indicating that the profile has been updated
        dispatch(setAlert('Group Updated', 'success'));

    } catch (err) {
        console.log('ERRORS')
        console.log(err);
        
        if(err.response) {
            const errors = err.response.data.errors;

            // Dispatch alerts for each error received from the server
            if(errors) {
                errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
            }
        } else {

            // Display a generic error message if no specific error response is received
            setAlert('Something went wrong', 'danger')
        }
    }
}

// Update group privacy setting
export const editGroupPrivacy = (formData) => async dispatch => {
    const { privacy, groupId } = formData;

    // Reference to the group document in the Firestore database
    const groupRef = doc(db, "campuses", groupId);

    console.log('UPDATING GROUP PRIVACY')

    // Try block to handle the update operation
    try {

        console.log('UPDATING GROUP PRIVACY')

        // Get updated User data for display
        const groupSnapshot = await getDoc(groupRef);

        if (!groupSnapshot.exists()) {
            console.log("Group doesn't exist");
            throw new Error("Group doesn't exist. Could't edit privacy");
        }

        let group_obj = {...groupSnapshot.data(), _id: groupId};

        // Update the group's privacy
        await updateDoc(groupRef, {
            privacy: privacy,
        })

        // Update group data for frontend display purposes (don't want to call DB a too many times in one function)
        group_obj.privacy = privacy;

        console.log('GOT UPDATED GROUP BY ID');
  
        // Dispatch an action to update the authenticated group's information with the updated data
        dispatch({
            type: UPDATE_GROUP,
            payload: group_obj
        });

        // Dispatch a success alert indicating that the profile has been updated
        dispatch(setAlert('Group Updated', 'success'));

    } catch (err) {
        console.log('ERRORS')
        console.log(err);
        
        if(err.response) {
            const errors = err.response.data.errors;

            // Dispatch alerts for each error received from the server
            if(errors) {
                errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
            }
        } else {

            // Display a generic error message if no specific error response is received
            setAlert('Something went wrong', 'danger')
        }
    }
}

// Update group Img
export const changeGroupImg = (imgData, groupId) => async dispatch => {
    
    dispatch(setGroupUpdateLoading());


    console.log('CHANGING GROUP IMG');

    console.log('IMG DATA: ');

    // Reference to the user document in the Firestore database
    const groupRef = doc(db, "campuses", groupId);

    // Get img file extension for firebase url
    var fileExt = imgData[0].name.split('.').pop();

    console.log('PHOTO FILE EXT');

    // Storage reference for the user's profile picture
    const storageRef = ref(storage, `media/groups/${groupId}/avatar/${imgData[0].name}`);

    try {

        // Get updated Group data for display
        const groupSnapshot = await getDoc(groupRef);

        if (!groupSnapshot.exists()) {
            console.log("Group doesn't exist");
            throw new Error("Group doesn't exist. Could't change page photo");
        }

        // Upload the image file to the specified storage location
        const res = await uploadBytesResumable(storageRef, imgData[0]);

        console.log('Uploaded a GROUP PIC file!');

        // Get the download URL of the uploaded image
        const photoURL = await getDownloadURL(storageRef);

        console.log('IMG PATH');

        console.log('UPDATING GROUPS IMG OBJ')

        let group_obj = {...groupSnapshot.data()};

        // Update the group's avatar
        await updateDoc(groupRef, {
            avatar: photoURL
        })

        // Update group data for frontend display purposes (don't want to call DB a too many times in one function)
        group_obj.avatar = photoURL;

        // --- UPDATE ALL USER POSTS ---

        // Query posts collection to fetch posts by group ID
        const postsQuery = query(postsCollectionRef,  where("group._id", "==", groupId));

        // Execute the query and retrieve the query snapshot
        const selectedPosts = await getDocs(postsQuery);

        // Map the query snapshot to an array of notification objects with document ID
        for (const doc of selectedPosts.docs) {

            const selectedPost = await getDoc(doc.ref);

            await updateDoc(doc.ref, {
                ...selectedPost.data(),
                group: {
                    ...selectedPost.data().group,
                    avatar: photoURL,
                },
            })
        };

        // END UPDATE POSTS

        dispatch({
            type: UPDATE_GROUP,
            payload: group_obj
        });

        // Dispatch a success alert to notify the group about the image update
        dispatch(setAlert('Group Updated!', 'success'));
        dispatch(setGroupUpdateLoaded());

    } catch (err) {
        console.log('ERRORS')
        console.log(err);
        
        if(err.response) {
            const errors = err.response.data.errors;

            // Dispatch error alerts for each error message received
            if(errors) {
                errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
            }
        } else {

            // Dispatch a generic error alert if no specific error information is available
            setAlert('Something went wrong', 'danger')
        }

        throw new Error("Error updating profile IMG");
    }
}

// Groups loading
export const setGroupsLoading = () => {
    return {
        type: GROUPS_LOADING
    }
}

// Remove current group info from state
export const clearGroup = () => dispatch => {
    dispatch({
        type: CLEAR_GROUP
    });

}

// Remove current group info from state
export const clearGroups = () => dispatch => {
    dispatch({
        type: CLEAR_GROUPS
    });

}

// Profile update loading
export const setGroupUpdateLoading = () => {
    return {
        type: GROUP_UPDATE_LOADING
    }
}

// Profile update loading
export const setGroupUpdateLoaded = () => {
    return {
        type: GROUP_UPDATE_LOADED
    }
}

// --- Infinite Scroll Functions ---

export const set_ShowBottomSpinner = (value) => dispatch => {

    dispatch({
        type: SET_SHOW_BOTTOM_SPINNER_4_GROUPS,
        payload: value
    });

}

export const set_LastPageDoc = (doc) => dispatch => {

    dispatch({
        type: SET_LAST_GROUP_DOC,
        payload: doc
    });

}

export const set_NoMoreUsers = (value) => dispatch => {

    dispatch({
        type: SET_NO_MORE_GROUPS,
        payload: value
    });

}

// --- END: Infinite Scroll Functions ---

// --- Helper functions ----

export const getFollowingGroups_Helper = async ({ currentUser, page_size }) => {
    
    console.log('GETTING FOLLOWING GROUPS');

    try {
        if(!currentUser) throw new Error('No user data');

        let groupsList = [];

        // Fetch My Groups
        for (const groupID of currentUser?.groups) {

            // Limit results length to page_size
            if(page_size && groupsList.length >= page_size) {
                break;
            }

            try {
                const groupRef = doc(db, 'campuses', groupID)

                // Retrieve the document with the specified id from the collection
                const groupDoc = await getDoc(groupRef);

                if(groupDoc.data()) {
                    const groupData = {
                        ...groupDoc.data(),
                        _id: groupID
                    }
    
                    // Don't include group IF the user an admin
                    if(groupData.admins?.includes(currentUser._id)) {
                        continue;
                    }
    
                    groupsList.push(groupData);
                }
        
            } catch (error) {
                console.log("Error: failed to fetch one following group");
                console.log(error);
            }
        }

        console.log('DONE FETCHING FOLLOWING GROUPS...');

        return groupsList;

    } catch (err) {
        console.log("ERROR! COULDN'T GET FOLLOWING GROUPS")
        console.log(err);

        throw new Error('Failed to get groups');
    }
};

export const getMyGroups_Helper = async ({ currentUser, lastPageDoc, page_size }) => {
    
    console.log('GETTING MY GROUPS');

    try {
        if(!currentUser) throw new Error('No user data');

        let q;

        if(lastPageDoc) {
            // Create a query to fetch notifications for the current user, starting at the last visible document and fetch the next 3
            q = query(groupsCollectionRef, where("admins", "array-contains", currentUser._id), orderBy('createdAt', 'desc'), startAfter(lastPageDoc || 0), limit(page_size));
        } else {
            q = query(groupsCollectionRef, where("admins", "array-contains", currentUser._id), orderBy('createdAt', 'desc'), limit(page_size));
        }
        const snapshot = await getDocs(q);
        
        const groupsList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        console.log('GOT MY GROUPS', groupsList);

        return groupsList;

    } catch (err) {
        console.log("ERROR! COULDN'T GET MY GROUPS")
        console.log(err);

        throw new Error('Failed to get groups');
    }
};

export const getGroupsBySearchTag_Helper = async ({ search_tag, lastPageDoc, page_size }) => {
    
    console.log('GETTING GROUPS BY SEARCH TAGS');

    try {
        if(!search_tag) throw new Error('No search tag provided');

        search_tag = search_tag.toLowerCase();

        let q;

        if(lastPageDoc) {
            // Create a query to fetch notifications for the current user, starting at the last visible document and fetch the next 3
            q = query(groupsCollectionRef, where("search_tags", "array-contains", search_tag), where("can_discover", "==", true), orderBy('follower_count', 'desc'), startAfter(lastPageDoc || 0), limit(page_size));
        } else {
            q = query(groupsCollectionRef, where("search_tags", "array-contains", search_tag), where("can_discover", "==", true), orderBy('follower_count', 'desc'), limit(page_size));
        }
        const snapshot = await getDocs(q);
        
        const groupsList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        console.log('GOT GROUPS BY SEARCH TAG', groupsList);

        return groupsList;

    } catch (err) {
        console.log("ERROR! COULDN'T GET GROUPS BY SEARCH TAG")
        console.log(err);

        throw new Error('Failed to get groups');
    }
};

export const getNewGroups_Helper = async ({ lastPageDoc, page_size }) => {
    
    console.log('GETTING NEW GROUPS');

    try {

        let q;

        if(lastPageDoc) {
            // Create a query to fetch groups, starting at the last visible document and fetch the next n
            q = query(groupsCollectionRef, where("can_discover", "==", true), orderBy('createdAt', 'desc'), startAfter(lastPageDoc || 0), limit(page_size));
        } else {
            q = query(groupsCollectionRef, where("can_discover", "==", true), orderBy('createdAt', 'desc'), limit(page_size));
        }
        const snapshot = await getDocs(q);
        
        const groupsList = snapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        console.log('GOT NEW GROUPS', groupsList);

        return groupsList;

    } catch (err) {
        console.log("ERROR! COULDN'T GET NEW GROUPS")
        console.log(err);

        throw new Error('Failed to get groups');
    }
};

// --- END: Helper Functions
